import { cn } from "@/lib/utils"

/** The wordmark (refined-system §5.7): serif "minga" and a 5px ink dot. */
export function LogoMark({ className }: { className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cn("inline-flex shrink-0 items-baseline gap-0.5 text-ink", className)}
    >
      <span className="font-serif text-[22px] leading-none tracking-[-0.02em]">minga</span>
      <span className="inline-block size-[5px] rounded-full bg-ink" />
    </span>
  )
}

export function Logo() {
  return <LogoMark />
}
